import {Component, ChangeDetectionStrategy} from "@angular/core";
import {ReactiveFormsModule} from "@angular/forms";
import {MatTableModule} from "@angular/material/table";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatInputModule} from "@angular/material/input";
import {MatListModule} from "@angular/material/list";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
    selector: "navigation-header",
    templateUrl: "./navigation-header.component.html",
    styleUrls: ["./navigation-header.component.scss"],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        MatListModule,
        MatSnackBarModule,
        MatIconModule,
        ReactiveFormsModule,
        MatButtonModule,
        RouterLinkActive,
        RouterLink,
    ]
})
export class NavigationHeaderComponent {}
